import O1HD from "../../../../engines/gameEngine";
import RobotItemNode from "./RobotItemNode";
import PlayerItemNode from "./PlayerItemNode";
import {EventParamsTypeConstant} from "../const/EventParamsTypeConstant";
import {RegisterSpecialEventEntity} from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

/**
 * 尊严内容Entity
 */
export interface DigitalContentEntity {
    content : string;//内容
    weight : number;//权重
}

/**
 * 尊严挑战
 */
@ccclass
export default class DigitalChallengePrefab extends cc.Component {

    @property(cc.Label)
    lbCutDown : cc.Label = null;
    @property(cc.ScrollView)
    scrollView : cc.ScrollView = null;
    @property(cc.Node)
    contentNode : cc.Node = null;
    @property({type:cc.Prefab,displayName:"机器人聊天预制体"})
    robotChatItemPrefab : cc.Prefab = null;
    @property({type:cc.Prefab,displayName:"玩家聊天预制体"})
    playerChatItemPrefab : cc.Prefab = null;

    readonly contentShoutArray : DigitalContentEntity[] = [
        {content:"哎",weight:19 },
        {content:"喊得越多给的越多哦",weight:9 },
        {content:"赚钱嘛，不寒掺",weight:9 },
        {content:"你真喊的啊？",weight:9 },
        {content:"我看你还挺闲？",weight:9 },
        {content:"从未有人因为赚钱而身败名裂的",weight:9 },
        {content:"态度好的人赚钱的机会比较多",weight:9 },
        {content:"有时候放开才能活的更开心",weight:9 },
        {content:"你知道钱财的重要性",weight:9 },
        {content:"小钱不知挣，大钱将不来",weight:9 },
    ];

    readonly contentBagpipeArray : DigitalContentEntity[] = [
        {content:"给钱你都不要的啊？",weight:13 },
        {content:"勤俭永不穷，坐食山也空啊",weight:13 },
        {content:"给你钱可以尊重我一下吗",weight:13 },
        {content:"只有生存下来才能拥有尊严",weight:13 },
        {content:"我只在意有你的消息？",weight:22 },
        {content:"你难道不好奇肠来肠往？",weight:13 },
        {content:"你还想站着把钱挣了？",weight:13 },
    ];

    //关闭回调
    private mCloseCallBack;
    //按钮 喊一声 开关
    private mSwitchShoutReply : boolean = true;
    private shoutCount : number = 0;
    //按钮 风笛 开关
    private mSwitchBagpipeReply : boolean = true;
    private bagpipeCount : number = 0;
    //倒计时
    private cutDownNum : number = 60;

    bindData( closeCallBack ){
        this.mCloseCallBack = closeCallBack;

    }

    onLoad () {

    }

    start () {
        this._robotChat("叫吧");
        //开始倒计时
        this.scheduleOnce(()=>{
           this.cutDown();
        });
    }

    //倒计时
    cutDown(){
        this.lbCutDown.string = `${--this.cutDownNum}S`;
        if ( this.cutDownNum == 0 ) {
            //游戏结束
            //根据 双方的次数 ，显示不同的文案
            let specialEventArray : RegisterSpecialEventEntity[] = [];
            let itemEntity : RegisterSpecialEventEntity = null;
            let content = "";
            if ( this.shoutCount > this.bagpipeCount ) {
                content = "你在生存和尊严中选择了生存，证明你是一个拥有着清晰头脑和遇事放得下身段的人，不过生存下来后获得到尊严可能更有感觉哦！";
            }else{
                content = "尊严和金钱在你眼里，金钱就像依托答辩";
            }
            itemEntity = {
                startHours : 0,
                waitHours : 0,
                desc : content,
                effectParams : []
            };
            specialEventArray.push(itemEntity);
            O1HD.emit("normalMode.setSpecialEventShow", specialEventArray );
            this.mCloseCallBack && this.mCloseCallBack();
            this.node.removeFromParent();
            this.node.destroy();
        }
        this.scheduleOnce(()=>{
            this.cutDown();
        },1);
    }
    /**
     *
     * @param type
     */
    getRandomReply( type : number ) : string {
        if ( type == 1 ){
            //喊一声
            return this.getRandomReplyShout();
        }else{
            //风笛
            return this.getRandomReplyBagpipe();
        }
    }

    /**
     * 选择
     * @param e
     * @param chooseDefine
     */
    onBtnChooseText( e , chooseDefine : string ){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( chooseDefine == "1" ){
            //喊一声
            if ( this.mSwitchShoutReply ) {
                //自己发送
                this._playerChat( "爸爸" );
                this.shoutCount ++;
                //机器人回复
                let robotReplay = this.getRandomReply( 1 );
                this._robotChat( robotReplay );
                //2秒控制开关
                this.mSwitchShoutReply = false;
                this.scheduleOnce(()=>{
                    this.mSwitchShoutReply = true;
                },2);
                this.scrollView.scrollToBottom(0.5);
                O1HD.getServices().userSrv.setCoins( 50, true , e.target );
            }
        }else{
            //风笛
            if ( this.mSwitchBagpipeReply ) {
                //自己发送
                this._playerChat( "远方传来风笛" );
                this.bagpipeCount ++;
                //机器人回复
                let robotReplay = this.getRandomReply( 2 );
                this._robotChat( robotReplay );
                //2秒控制开关
                this.mSwitchBagpipeReply = false;
                this.scheduleOnce(()=>{
                    this.mSwitchBagpipeReply = true;
                },2);
                this.scrollView.scrollToBottom(0.5);
                O1HD.getServices().userSrv.setCoins( 20 , true , this.node );
            }
        }
    }

    /**
     * 玩家回复
     */
    private _playerChat( content : string ){
        let playerChatItemNode = cc.instantiate( this.playerChatItemPrefab );
        playerChatItemNode.getComponent( PlayerItemNode ).bindData( content );
        this.contentNode.addChild( playerChatItemNode ) ;
    }
    /**
     * 机器人回复
     * @param content
     * @private
     */
    private _robotChat( content : string ){
        let robotChatItemNode = cc.instantiate( this.robotChatItemPrefab );
        robotChatItemNode.getComponent( RobotItemNode ).bindData( content );
        this.contentNode.addChild( robotChatItemNode );
    }
    //获取喊一声的回复
    getRandomReplyShout(){
        let randomNum = Math.floor( Math.random() * 100 );
        for ( let contentItem of this.contentShoutArray ) {
            if ( randomNum < contentItem.weight ) {
                return contentItem.content;
            }
            randomNum -= contentItem.weight;
        }
    }
    //获取风笛的回复
    getRandomReplyBagpipe(){
        let randomNum = Math.floor( Math.random() * 100 );
        for ( let contentItem of this.contentBagpipeArray ) {
            if ( randomNum < contentItem.weight ) {
                return contentItem.content;
            }
            randomNum -= contentItem.weight;
        }
    }

    /**
     *
     */
    onBtnExit(){
        this.mCloseCallBack && this.mCloseCallBack();
        this.node.removeFromParent();
        this.node.destroy();
    }
}
